<template>
  <section>
    <ul class="list-reset p-10 bg-blue-light-1 mdsm:p-6">
      <li class="flex items-center text-base">
        <svg width="24" height="24" class="inline-block mr-3">
          <use xlink:href="/img/sprite.svg#ic_above-deck-cabins" />
        </svg>
        <span>Number of cabins:</span>
        <strong class="inline-block ml-2">{{ numberOfCabin }}</strong>
      </li>

      <li class="flex items-center mt-6 mdsm:mt-4 text-base">
        <svg width="24" height="24" class="inline-block mr-3">
          <use xlink:href="/img/sprite.svg#ic_wifi" />
        </svg>
        <span>Internet:</span>
        <strong class="inline-block ml-2">{{
          hasInternet ? "YES" : "NO"
        }}</strong>
      </li>

      <li class="flex items-center mt-6 mdsm:mt-4 text-base">
        <svg width="24" height="24" class="inline-block mr-3">
          <use xlink:href="/img/sprite.svg#ic_nitrox" />
        </svg>
        <span>Nitrox:</span>
        <strong class="inline-block ml-2">{{
          hasNitrox ? "YES" : "NO"
        }}</strong>
      </li>

      <li class="flex items-center mt-6 mdsm:mt-4 text-base">
        <svg width="24" height="24" class="inline-block mr-3">
          <use xlink:href="/img/sprite.svg#ic_equipment" />
        </svg>
        <span>Equipment rental:</span>
        <strong class="inline-block ml-2">{{
          hasEquipmentRental ? "YES" : "NO"
        }}</strong>
      </li>

      <li
        v-if="diveGuideRatio"
        class="flex items-center mt-6 mdsm:mt-4 text-base"
      >
        <svg width="24" height="24" class="inline-block mr-3">
          <use xlink:href="/img/sprite.svg#ic_people" />
        </svg>
        <span>Guest / Guide:</span>
        <strong class="inline-block ml-2">{{ diveGuideRatio }}</strong>
      </li>

      <li class="flex items-center mt-6 mdsm:mt-4" v-if="!!groupBooking">
        <a
          href="#"
          class="flex item-centers"
          @click.prevent.stop="$refs.groupBookingModal.show()"
        >
          <svg width="24" height="24" class="inline-block mr-3 text-marine">
            <use xlink:href="/img/sprite.svg#ic_deal-solid" />
          </svg>
          <span class="cursor-pointer underline text-base"
            >Group booking discounts</span
          >
          <svg width="20" height="20" class="inline-block ml-1">
            <use xlink:href="/img/sprite.svg#ic_info" />
          </svg>
        </a>
      </li>

      <li class="flex items-center mt-6 mdsm:mt-4" v-if="hasBookingTerm">
        <a
          href="#"
          class="flex item-centers"
          @click.prevent.stop="$refs.bookingTermModal.show()"
        >
          <svg width="24" height="24" class="inline-block mr-3 text-marine">
            <use xlink:href="/img/sprite.svg#ic_booking-solid" />
          </svg>
          <span class="cursor-pointer underline text-base"
            >Flexible booking terms</span
          >
          <svg width="20" height="20" class="inline-block ml-1">
            <use xlink:href="/img/sprite.svg#ic_info" />
          </svg>
        </a>
      </li>
    </ul>

    <zb-modal
      no-padding
      ref="groupBookingModal"
      class="slide-in-modal booking-term-modal"
      v-if="!!groupBooking"
    >
      <template v-slot:title>
        <div class="font-medium text-base flex items-center">
          <svg width="24" height="24" class="inline-block mr-3">
            <use xlink:href="/img/sprite.svg#ic_deal-solid" />
          </svg>
          Group booking policy
        </div>
      </template>
      <template v-slot:default>
        <div v-html="groupBooking" class="p-6 booking-term-modal-body" />
      </template>
    </zb-modal>

    <zb-modal
      no-padding
      ref="bookingTermModal"
      class="slide-in-modal booking-term-modal"
      v-if="hasBookingTerm"
    >
      <template v-slot:title>
        <div class="font-medium text-base flex items-center">
          <svg
            class="icon-booking"
            fill="currentColor"
            width="24"
            height="24"
            v-if="bookingTerm.type === 'flexible'"
          >
            <use xlink:href="/img/sprite.svg#ic_booking-hollow" />
          </svg>
          <svg
            class="icon-booking"
            fill="currentColor"
            width="24"
            height="24"
            v-if="bookingTerm.type === 'super_flexible'"
          >
            <use xlink:href="/img/sprite.svg#ic_booking-solid" />
          </svg>
          {{ bookingTerm.title }} booking terms
        </div>
      </template>
      <template v-slot:default>
        <div
          v-html="bookingTermDescription"
          class="p-6 booking-term-modal-body"
        />
      </template>
    </zb-modal>
  </section>
</template>

<script>
import sumBy from "lodash/sumBy";
import get from "lodash/get";

export default {
  name: "LiveaboardSidebar",
  props: ["resortId"],
  data() {
    return {
      supplierInfo: {},
    };
  },
  computed: {
    numberOfCabin() {
      return sumBy(this.supplierInfo.rooms, (o) => o.available_rooms);
    },
    hasInternet() {
      return (this.supplierInfo.inclusions || []).some((o) =>
        ["WiFi", "Internet"].includes(o.name)
      );
    },
    hasNitrox() {
      return (this.supplierInfo.inclusions || []).some(
        (o) => o.name === "Nitrox"
      );
    },
    hasEquipmentRental() {
      return (this.supplierInfo.inclusions || []).some(
        (o) => o.name === "Equipment rental"
      );
    },
    diveGuideRatio() {
      return get(this.supplierInfo, "supplier.dive_guide_ratio");
    },
    hasBookingTerm() {
      return (
        typeof get(this.supplierInfo, "supplier.booking_term") === "object"
      );
    },
    groupBooking() {
      return get(this.supplierInfo, "supplier.group_booking_policy");
    },
    bookingTerm() {
      return typeof get(this.supplierInfo, "supplier.booking_term") === "object"
        ? get(this.supplierInfo, "supplier.booking_term")
        : {};
    },
    bookingTermDescription() {
      return (
        this.supplierInfo.supplier.cancelation_policy ||
        this.bookingTerm.description
      );
    },
  },
  mounted() {
    window
      .fetchSupplierInfo(this.resortId)
      .then((response) => {
        this.supplierInfo = response;
      })
      .catch(() => {
        this.supplierInfo = {};
      });
  },
};
</script>

<style lang="scss" scoped>
.booking-term-modal {
  &-body {
    ol,
    ul {
      list-style: initial;
      margin-block-start: 1em;
      padding-inline-start: 40px;

      li {
        margin-bottom: 0.5rem;
      }
    }

    ol {
      list-style-type: decimal;
    }
  }

  .zb-modal-title-container {
    border-radius: 4px;
    padding: 0.5rem 1rem;
    background: var(--blue-light-3);

    .zb-modal-close {
      padding: 0;
    }
  }
}
</style>
